import React from 'react';
import { keepInView } from './dom';

/**
 * Preset ranges ("7 days", "30 days", "All time") + a custom From → To. A custom date
 * overrides the preset; ✕ goes back to it. Shared by History and the checklist Summary.
 *
 *   presets       [days, …]          presetLabel(days) → text
 *   days / onPreset                  the picked preset
 *   from, to / onFrom, onTo, onClear the custom bounds ('' = open)
 *   max                              latest pickable day; fromAria / toAria / clearLabel
 */
export function DateRange({ presets, presetLabel, days, onPreset, from, to, onFrom, onTo, onClear, max, fromAria, toAria, clearLabel }) {
  const custom = !!(from || to);
  return (
    <>
      <div className="do-seg">
        {presets.map(d => (
          <button key={d} type="button" className={`do-seg__btn${!custom && days === d ? ' do-seg__btn--on' : ''}`}
            onClick={() => onPreset(d)}>{presetLabel(d)}</button>
        ))}
      </div>
      <div className="do-audit__dates">
        <input className="do-audit__date" type="date" value={from} max={to || max} onFocus={keepInView}
          onChange={e => onFrom(e.target.value)} aria-label={fromAria} />
        <span className="do-audit__dash">→</span>
        <input className="do-audit__date" type="date" value={to} min={from || undefined} max={max} onFocus={keepInView}
          onChange={e => onTo(e.target.value)} aria-label={toAria} />
        {custom && <button type="button" className="do-audit__clear" onClick={onClear} title={clearLabel} aria-label={clearLabel}>✕</button>}
      </div>
    </>
  );
}
